import { Component, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/_services/navigation.service';

@Component({
  selector: 'app-hippa-certificate',
  templateUrl: './hippa-certificate.component.html',
  styleUrls: ['./hippa-certificate.component.scss']
})
export class HippaCertificateComponent implements OnInit {

  constructor(
    public navigationService: NavigationService
  ) { }

  ngOnInit() {
  }

}
